import React from 'react'
import education from '../../Image/educatin.svg'
import health from '../../Image/health.svg'
import ecommerce from '../../Image/ecommerce.svg'
import fitness from '../../Image/fitness.svg'
import social from '../../Image/social.svg'
import life from '../../Image/life.svg'
import real from '../../Image/realestate.svg'
import truck from '../../Image/truck.svg'
import finance from '../../Image/finance.svg'
import travel from '../../Image/travel.svg'
import food from '../../Image/food.svg'
import Marquee from "react-fast-marquee";



const CoreService = () => {


  
  return (
    <div className='bg-theme_light ds_core_shdow'>
       <div className='sx:pb-[60px] pb-5 '>
          <h2 className="text-2xl  sm:text-3xl 2xl:text-[40px] font-[700] text-center pt-8">Our Core Services</h2>
        <div className='lg:block hidden'>
           <div className='flex lg:flex-nowrap flex-wrap justify-center mt-7'>
              <div className='2xl:w-[12%] xl:w-[14%] lg:w-1/6 md:w-1/4 w-1/4 relative'>
                <div className='flex justify-center flex-col items-center'>
                   <img src={education} alt="" className='sm:w-[60px] w-[50px]'/>
                   <h4 className='sm:sm:text-[14px]] sm:text-[14px]] font-[600] mt-2 '>Education</h4>
                </div>
                <div className='absolute right-0 top-0 h-[45px] w-[1px] bg-[#555555CC]'></div>
              </div>
              <div className='2xl:w-[12%] xl:w-[14%] lg:w-1/6 md:w-1/4 w-1/4 relative'>
                <div className='flex justify-center flex-col items-center'>
                   <img src={health} alt="" className='sm:w-[60px] w-[50px]'/>
                   <h4 className='sm:sm:text-[14px]] sm:text-[14px]] font-[600] mt-2 '>Health Care</h4>
                </div>
                <div className='absolute right-0 top-0 h-[45px] w-[1px] bg-[#555555CC]'></div>
              </div>
              <div className='2xl:w-[12%] xl:w-[14%] lg:w-1/6 md:w-1/4 w-1/4 relative'>
                <div className='flex justify-center flex-col items-center'>
                   <img src={ecommerce} alt="" className='sm:w-[60px] w-[50px]'/>
                   <h4 className='sm:sm:text-[14px]] sm:text-[14px]] font-[600] mt-2 '>E-commerce</h4>
                </div>
                <div className='md:absolute right-0 top-0 md:h-[45px] md:w-[1px] bg-[#555555CC]'></div>
              </div>
              <div className='2xl:w-[12%] xl:w-[14%] lg:w-1/6 md:w-1/4 w-1/4 relative md:mt-0 mt-4'>
                <div className='flex justify-center flex-col items-center'>
                   <img src={fitness} alt="" className='sm:w-[60px] w-[50px]'/>
                   <h4 className='sm:sm:text-[14px]] sm:text-[14px]] font-[600] mt-2 '>Fitness</h4>
                </div>
                <div className='lg:block md:hidden block absolute  right-0 top-0 h-[45px] w-[1px] bg-[#555555CC]'></div>
              </div>
              <div className='2xl:w-[12%] xl:w-[14%] lg:w-1/6 md:w-1/4 w-1/4 relative lg:mt-0 mt-4'>
                <div className='flex justify-center flex-col items-center'>
                   <img src={social} alt="" className='sm:w-[60px] w-[50px]'/>
                   <h4 className='sm:sm:text-[14px]] sm:text-[14px]] font-[600] mt-2 '>Social Network</h4>
                </div>
              </div>
           </div>
           <div className='flex justify-center mt-10'>
              <div className='2xl:w-[12%] xl:w-[14%] lg:w-1/6 md:w-1/4 w-1/4 relative'>
                <div className='flex justify-center flex-col items-center'>
                   <img src={life} alt="" className='w-[60px]'/>
                   <h4 className='sm:sm:text-[14px]] sm:text-[14px]] font-[600] mt-2 '>Lifestyle</h4>
                </div>
                <div className='absolute right-0 top-0 h-[45px] w-[1px] bg-[#555555CC]'></div>
              </div>
              <div className='2xl:w-[12%] xl:w-[14%] lg:w-1/6 md:w-1/4 w-1/4 relative'>
                <div className='flex justify-center flex-col items-center'>
                   <img src={real} alt="" className='w-[60px]'/>
                   <h4 className='sm:sm:text-[14px]] sm:text-[14px]] font-[600] mt-2 '>Real Estate</h4>
                </div>
                <div className='absolute right-0 top-0 h-[45px] w-[1px] bg-[#555555CC]'></div>
              </div>
              <div className='2xl:w-[12%] xl:w-[14%] lg:w-1/6 md:w-1/4 w-1/4 relative'>
                <div className='flex justify-center flex-col items-center'>
                   <img src={truck} alt="" className='w-[60px]'/>
                   <h4 className='sm:sm:text-[14px]] sm:text-[14px]] font-[600] mt-2 '>Transportation</h4>
                </div>
                <div className='absolute right-0 top-0 h-[45px] w-[1px] bg-[#555555CC]'></div>
              </div>
              <div className='2xl:w-[12%] xl:w-[14%] lg:w-1/6 md:w-1/4 w-1/4 relative'>
                <div className='flex justify-center flex-col items-center'>
                   <img src={finance} alt="" className='w-[60px]'/>
                   <h4 className='sm:sm:text-[14px]] sm:text-[14px]] font-[600] mt-2 '>Finance</h4>
                </div>
              </div>
           </div>
           <div className='flex justify-center mt-10'>
              <div className='2xl:w-[12%] xl:w-[14%] lg:w-1/6 md:w-1/4 w-1/4 relative'>
                <div className='flex justify-center flex-col items-center'>
                   <img src={travel} alt="" className='w-[60px]'/>
                   <h4 className='sm:sm:text-[14px]] sm:text-[14px]] font-[600] mt-2 '>Travel</h4>
                </div>
                <div className='absolute right-0 top-0 h-[45px] w-[1px] bg-[#555555CC]'></div>
              </div>
              <div className='2xl:w-[12%] xl:w-[14%] lg:w-1/6 md:w-1/4 w-1/4 relative'>
                <div className='flex justify-center flex-col items-center'>
                   <img src={real} alt="" className='w-[60px]'/>
                   <h4 className='sm:sm:text-[14px]] sm:text-[14px]] font-[600] mt-2 text-center leading-[20px] px-3'>Event Management</h4>
                </div>
                <div className='absolute right-0 top-0 h-[45px] w-[1px] bg-[#555555CC]'></div>
              </div>
              <div className='2xl:w-[12%] xl:w-[14%] lg:w-1/6 md:w-1/4 w-1/4 relative'>
                <div className='flex justify-center flex-col items-center'>
                   <img src={food} alt="" className='w-[60px]'/>
                   <h4 className='sm:sm:text-[14px]] sm:text-[14px]] font-[600] mt-2 '>Food & Drink</h4>
                </div>
              </div>
           </div>
        </div>

        <div className='container lg:hidden block mt-7'>
           <Marquee speed="50" pauseOnHover="false" className='cursor-pointer'>
              <div className='2xl:w-[12%] xl:w-[14%]  w-full  mx-11 relative'>
                <div className='flex justify-center flex-col items-center'>
                   <img src={education} alt="" className='sm:w-[60px] w-[50px]'/>
                   <h4 className='sm:sm:text-[14px]] sm:text-[14px]] font-[600] mt-2 '>Education</h4>
                </div>
                <div className='sm:block hidden absolute right-0 top-0 h-[45px] w-[1px] bg-[#555555CC]'></div>
              </div>
              <div className='2xl:w-[12%] xl:w-[14%]  w-full  mx-11 relative'>
                <div className='flex justify-center flex-col items-center'>
                   <img src={health} alt="" className='sm:w-[60px] w-[50px]'/>
                   <h4 className='sm:sm:text-[14px]] sm:text-[14px]] font-[600] mt-2 '>Health Care</h4>
                </div>
                <div className='sm:block hidden absolute right-0 top-0 h-[45px] w-[1px] bg-[#555555CC]'></div>
              </div>
              <div className='2xl:w-[12%] xl:w-[14%]  w-full  mx-11 relative'>
                <div className='flex justify-center flex-col items-center'>
                   <img src={ecommerce} alt="" className='sm:w-[60px] w-[50px]'/>
                   <h4 className='sm:sm:text-[14px]] sm:text-[14px]] font-[600] mt-2 '>E-commerce</h4>
                </div>
                <div className='sm:block hidden absolute right-0 top-0 h-[45px] w-[1px] bg-[#555555CC]'></div>
              </div>
              <div className='2xl:w-[12%] xl:w-[14%]  w-full  mx-11 relative '>
                <div className='flex justify-center flex-col items-center'>
                   <img src={fitness} alt="" className='sm:w-[60px] w-[50px]'/>
                   <h4 className='sm:sm:text-[14px]] sm:text-[14px]] font-[600] mt-2 '>Fitness</h4>
                </div>
                <div className='sm:block hidden absolute  right-0 top-0 h-[45px] w-[1px] bg-[#555555CC]'></div>
              </div>
              <div className='2xl:w-[12%] xl:w-[14%]  w-full  mx-11 relative '>
                <div className='flex justify-center flex-col items-center'>
                   <img src={social} alt="" className='sm:w-[60px] w-[50px]'/>
                   <h4 className='sm:sm:text-[14px]] sm:text-[14px]] font-[600] mt-2 '>Social Network</h4>
                </div>
                <div className='sm:block hidden absolute right-0 top-0 h-[45px] w-[1px] bg-[#555555CC]'></div>
              </div>
              <div className='2xl:w-[12%] xl:w-[14%]  w-full  mx-11 relative'>
                <div className='flex justify-center flex-col items-center'>
                   <img src={life} alt="" className='sm:w-[60px] w-[50px]'/>
                   <h4 className='sm:sm:text-[14px]] sm:text-[14px]] font-[600] mt-2 '>Lifestyle</h4>
                </div>
                <div className='sm:block hidden absolute right-0 top-0 h-[45px] w-[1px] bg-[#555555CC]'></div>
              </div>
              <div className='2xl:w-[12%] xl:w-[14%]  w-full  mx-11 relative'>
                <div className='flex justify-center flex-col items-center'>
                   <img src={real} alt="" className='sm:w-[60px] w-[50px]'/>
                   <h4 className='sm:sm:text-[14px]] sm:text-[14px]] font-[600] mt-2 '>Real Estate</h4>
                </div>
                <div className='sm:block hidden absolute right-0 top-0 h-[45px] w-[1px] bg-[#555555CC]'></div>
              </div>
              <div className='2xl:w-[12%] xl:w-[14%]  w-full  mx-11 relative'>
                <div className='flex justify-center flex-col items-center'>
                   <img src={truck} alt="" className='sm:w-[60px] w-[50px]'/>
                   <h4 className='sm:sm:text-[14px]] sm:text-[14px]] font-[600] mt-2 '>Transportation</h4>
                </div>
                <div className='sm:block hidden absolute right-0 top-0 h-[45px] w-[1px] bg-[#555555CC]'></div>
              </div>
              <div className='2xl:w-[12%] xl:w-[14%]  w-full  mx-11 relative'>
                <div className='flex justify-center flex-col items-center'>
                   <img src={finance} alt="" className='sm:w-[60px] w-[50px]'/>
                   <h4 className='sm:sm:text-[14px]] sm:text-[14px]] font-[600] mt-2 '>Finance</h4>
                </div>
                <div className='sm:block hidden absolute right-0 top-0 h-[45px] w-[1px] bg-[#555555CC]'></div>
              </div>
              <div className='2xl:w-[12%] xl:w-[14%]  w-full  mx-11 relative'>
                <div className='flex justify-center flex-col items-center'>
                   <img src={travel} alt="" className='sm:w-[60px] w-[50px]'/>
                   <h4 className='sm:sm:text-[14px]] sm:text-[14px]] font-[600] mt-2 '>Travel</h4>
                </div>
                <div className='sm:block hidden absolute right-0 top-0 h-[45px] w-[1px] bg-[#555555CC]'></div>
              </div>
              <div className='2xl:w-[12%] xl:w-[14%]  w-full  mx-11 relative'>
                <div className='flex justify-center flex-col items-center'>
                   <img src={real} alt="" className='sm:w-[60px] w-[50px]'/>
                   <h4 className='sm:sm:text-[14px]] sm:text-[14px]] font-[600] mt-2 text-center leading-[20px] mb-3'>Event <br/> Management</h4>
                </div>
                <div className='sm:block hidden absolute right-0 top-0 h-[45px] w-[1px] bg-[#555555CC]'></div>
              </div>
              <div className='2xl:w-[12%] xl:w-[14%]  w-full  mx-11 relative'>
                <div className='flex justify-center flex-col items-center'>
                   <img src={food} alt="" className='sm:w-[60px] w-[50px]'/>
                   <h4 className='sm:sm:text-[14px]] sm:text-[14px]] font-[600] mt-2 '>Food & Drink</h4>
                </div>
                <div className='sm:block hidden absolute right-0 top-0 h-[45px] w-[1px] bg-[#555555CC]'></div>
              </div>
           </Marquee>
        </div>
       </div>
    </div>
  )
}

export default CoreService
